var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",attrs:{"role":"banner"}},[_c('div',{staticClass:"header__wrapper"},[_c('h1',{staticClass:"site-logo"},[_c('router-link',{staticClass:"site-logo__anchor",attrs:{"to":"/"}},[_c('span',{staticClass:"blind"},[_vm._v("TOOOOL")])])],1),_c('header-nav'),_c('header-util')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d4613a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-header/index.vue
// module id = null
// module chunks = 